import { render, staticRenderFns } from "./MapNavigationPlacesType.vue?vue&type=template&id=e315c74c&"
import script from "./MapNavigationPlacesType.vue?vue&type=script&lang=js&"
export * from "./MapNavigationPlacesType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapNavigationBackButton: require('/srv/rir-platform/tourism/src/tourism-front/components/common/MapNavigation/MapNavigationBackButton.vue').default,HorizontalEntityCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/HorizontalEntityCard/index.vue').default,Empty: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Empty/index.vue').default})
